import styles from "./CompraFinalizada.module.css";
import Logo from "../../assets/LogoPrincipal.png";
import Header from "../../components/Header/Header";
import SubHeader from "../../components/SubHeader/SubHeader";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";
import api, { socketBaseUrl } from "../../utils/axios/api";

type Message = {
  valid: "PAYED" | "CANCELLED"
}

export default function CompraFinalizada() {
  const location = useLocation()
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    window.innerWidth < 768
  );

  function handleWindowSizeChange() {
    setIsSmallScreen(window.innerWidth < 768);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    // Executar uma vez no início para garantir que o estado é atualizado com a largura da janela atual
    handleWindowSizeChange();

    return () => window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  const {
    qr_code_base64,
    qr_code,
    date_created,
    date_of_expiration,
    amount,
    orderId,
    typePayment
  } = location.state || {}

  const [buySuccess, setBuySuccess] = useState(typePayment === 'pix' ? false : true)

  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    async function getStatusOrder(){
      try {
        const res = await api.get(`/order/${orderId}`)
        console.log(res.data)

        const order = res.data

        if(order.status !== 'CANCELED' && order.status !== 'PAYMENT_PENDING')
          setBuySuccess(true)
      } catch (error) {
        alert('Não foi possível pegar os dados do pedido')
      }
    }

    getStatusOrder()
  }, [])

  useEffect(() => {
    function connectSocket() {
      if (!socket) {
        const socketInstance = io(socketBaseUrl);
        setSocket(socketInstance);
        return
      }
      try {
        socket.on("payment status", (data: Message) => {
          if (data.valid === 'PAYED') setBuySuccess(true)
          else setBuySuccess(false)
        });

        if (socket) {
          socket.emit('login', orderId)
          console.log('tamo on')
        }

      } catch (error) {
        console.log(error)
      }
    }

    connectSocket()

    // Cleanup: desconectar o socket ao desmontar o componente
    return () => {
      if (socket)
        socket.disconnect();
    };
  }, [socket]);

  const { t } = useTranslation();
  return (
    <div>
      <Header
        boxShadow
        mobileMenuActiveState={isMobileMenuVisible}
        toggleMobileMenu={setIsMobileMenuVisible}
        isSmallScreen={isSmallScreen}
        hamburgerIcon={false}
      />
      <div className={styles.SubHeader}>
        <SubHeader />
      </div>
      {buySuccess ? <div className={styles.content}>
        <div className={styles.esquerda}>
          <img className={styles.logo} src={Logo} alt="logo" />
        </div>
        <div className={styles.direita}>
          <div>
            <p className={styles.principal}>{t('compra.comprafinalizada')}</p>
            <span>{orderId}</span>
          </div>
          <p className={styles.secundario}>{t('compra.confianca')}</p>
          <p className={styles.terciario}>{t('compra.acompanhe')}</p>
        </div>
        <div className={styles.coringa}></div>
      </div> :
        <div className={styles.content} style={{ flexDirection: 'column' }}>
          <h1>Aguardando Pagamento</h1>
          <h4>{orderId}</h4>
          <img src={`data:image/png;base64,${qr_code_base64}`}
            style={{ width: '200px', height: '200px', marginTop: 32 }}
          />
          <span onClick={() => navigator.clipboard.writeText(qr_code)} className={styles.qrCodeSpan}>{qr_code}</span>
        </div>}
      {!isSmallScreen && <Footer />}
    </div>
  )
}